import request from '@/utils/request';

// 登录
export function Login(data) {
    return request({
        url: '/wisc/youth/login',
        method: 'POST',
        data
    });
}

// 获取汉字点选验证码
export function QueryClickCaptcha() {
    return request({
        url: '/wisc/youth/login/clickCaptcha',
        method: 'GET'
    });
}

// 校验汉字点选验证码
export function VerifyClickCaptcha(data) {
    return request({
        url: '/wisc/youth/login/verifyClickCaptcha',
        method: 'POST',
        data
    });
}
